<div class="container-fluid modal-content-promo">
  <form [formGroup]="agregarForm" mat-dialog-content>
    <div class="row">
      <div class="col-lg-6">
        <app-lfsa-input [control]="this.agregarForm.get('id_promo')" [id]="'id_promo'" [isReadOnly]="!isCreate"
          [label]="'ID PROMO'" formControlName="id_promo" type="text"></app-lfsa-input>
        <div class="letrasDanger" *ngIf="this.agregarForm.get('id_promo').hasError('existePromocion')"><small>Promoción ya existe</small></div>
      </div>
      <div class="col-lg-6">
        <app-lfsa-input [control]="this.agregarForm.get('descripcion_corta')" [id]="'descripcion_corta'"
          [isReadOnly]="false" [label]="'Descripción corta'" formControlName="descripcion_corta"
          type="text"></app-lfsa-input>
      </div>
      <div class="col-lg-12">
        <app-lfsa-input [control]="this.agregarForm.get('descripcion_larga')" [id]="'descripcion_larga'"
          [isReadOnly]="false" [label]="'Descripción larga'" formControlName="descripcion_larga"
          type="text"></app-lfsa-input>
      </div>
      <div class="col-lg-6">
        <label for="tipo_promo">Tipo de Promoción</label>
        <select (change)="onChangeTipoOnSelect($event)" class="form-control form-select" formControlName="tipo_promo">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let data of cmbTipoPromocion" [value]="data.id">{{ data.descripcion }}</option>
        </select>
      </div>
      <div class="col-lg-3">
        <app-lfsa-input [control]="this.agregarForm.get('fecha_inicio')" [id]="'fecha_inicio'" [isReadOnly]="false"
          [label]="'Fecha Inicio'" formControlName="fecha_inicio" type="date"></app-lfsa-input>
      </div>
      <div class="col-lg-3">
        <app-lfsa-input [control]="this.agregarForm.get('fecha_fin')" [id]="'fecha_fin'" [isReadOnly]="false"
          [label]="'Fecha Fin'" formControlName="fecha_fin" type="date"></app-lfsa-input>
        <div class="text-danger small" *ngIf="fechaFinalMenorQueFechaInicial">
          Fecha Fin no puede ser menor a Fecha Inicio
        </div>
      </div>
      <div class="col-lg-3">
        <label for="promo_exclusiva_hh">Promo Exclusiva HH</label>
        <select class="form-control form-select" formControlName="promo_exclusiva_hh" id="promo_exclusiva_hh">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let data of cmbSiNo" [value]="data.id">{{ data.descripcion }}</option>
        </select>
      </div>
      <div class="col-lg-3">
        <label for="excluye_bonificacion_hh">Excluye Promos HH</label>
        <select class="form-control form-select" formControlName="excluye_bonificacion_hh" id="excluye_bonificacion_hh">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let data of cmbExcluyePromosHH" [value]="data.id">{{ data.descripcion }}</option>
        </select>
      </div>

      <div class="col-lg-3 mb-3">
        <label for="aplica_proporcionalidad">Aplica proporcionalidad</label>
        <select class="form-control form-select" formControlName="aplica_proporcionalidad" id="aplica_proporcionalidad">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let data of cmbSiNo" [value]="data.id">{{ data.descripcion }}</option>
        </select>
      </div>
      <div class="col-lg-3">
        <label for="especif_calculo_cantidad">Especif. Cálculo Cantidad</label>
        <select class="form-control form-select" formControlName="especif_calculo_cantidad" id="especif_calculo_cantidad">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let data of cmbEspecifCalculoCantidad" [value]="data.id">{{ data.descripcion }}</option>
        </select>
        <app-lfsa-error-msg [control]="this.agregarForm.get('especif_calculo_cantidad')" label="Especif. Cálculo Cantidad"></app-lfsa-error-msg>
      </div>
      <div class="col-lg-3">
        <app-lfsa-input [control]="this.agregarForm.get('cantidad_minima')" [id]="'cantidad_minima'"
          [isReadOnly]="false" [label]="'Cantidad mínima'" formControlName="cantidad_minima"
          [type]="'number'"></app-lfsa-input>
      </div>
      <div class="col-lg-3">
        <app-lfsa-input [control]="this.agregarForm.get('cantidad_maxima')" [id]="'cantidad_maxima'"
          [isReadOnly]="false" [label]="'Cantidad máxima'" formControlName="cantidad_maxima"
          [type]="'number'"></app-lfsa-input>
      </div>
      <div class="col-lg-3">
        <label for="control_cantidad">Control Cantidad (Und)</label>
        <select class="form-control form-select" formControlName="control_cantidad" id="control_cantidad">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let data of cmbControlCantidad" [value]="data.id">{{ data.descripcion }}</option>
        </select>
      </div>
      <div class="col-lg-3">
        <label for="control_maximo">Control Máximo</label>
        <select class="form-control form-select" formControlName="control_maximo" id="control_maximo">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let data of cmbControlMaximo" [value]="data.id">{{ data.descripcion }}</option>
        </select>
      </div>
      <div class="col-lg-3">
        <!-- <app-lfsa-combo-box [comboBox]="cmbSiNo" [control]="agregarForm.get('cambio_condicion_pago') | formControl"
          [idOpcion]="'cambio_condicion_pago'" [id]="'id'" [label]="'Cambio cond. Pago'" [opcion]="'descripcion'"
          formControlName="cambio_condicion_pago" [isReadOnly]="true">
        </app-lfsa-combo-box> -->
        <label for="cambio_condicion_pago">Cambio cond. Pago</label>
        <select class="form-control form-select" formControlName="cambio_condicion_pago" id="cambio_condicion_pago">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let data of cmbSiNo" [value]="data.id">{{ data.descripcion }}</option>
        </select>
      </div>
      <div class="col-lg-3">
        <!-- <app-lfsa-input [control]="this.agregarForm.get('condicion_pago')" [id]="'condicion_pago'"
          [isReadOnly]="false" [label]="'Condición Pago'" formControlName="condicion_pago"
          type="number"></app-lfsa-input> -->
        <label for="condicion_pago">Condición Pago</label>
        <select class="form-control form-select" formControlName="condicion_pago" id="condicion_pago"
          [disabled]="condicionPagoDisabled">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let data of cmbCondicionPago" [value]="data.id">{{ data.descripcion }}</option>
        </select>
      </div>
      <div class="col-lg-3" *ngIf="!isCreate">
        <label for="suma_por_grupos">Suma x Grupos</label>
        <div class="input-group">
          <select class="form-control form-select" formControlName="suma_por_grupos" id="suma_por_grupos">
            <option value="">Seleccione una opción</option>
            <option *ngFor="let data of cmbSiNo" [value]="data.id">{{ data.descripcion }}</option>
          </select>
          <button
            class="btn btn-outline-success"
            [routerLink]="['grupos']"
            tooltip="Grupos"
            [options]="{'placement': 'top', 'showDelay': 300}"
            *ngIf="agregarForm.get('suma_por_grupos').value == 1">
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>
      <div class="col-lg-3">
        <label for="aplica_compensacion">Aplica Compensación</label>
        <select class="form-control form-select" formControlName="aplica_compensacion" id="aplica_compensacion">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let data of cmbSiNo" [value]="data.id">{{ data.descripcion }}</option>
        </select>
      </div>
      <div class="col-lg-3">
        <app-lfsa-input [control]="this.agregarForm.get('porcentaje_descuento')" [id]="'porcentaje_descuento'"
          [isReadOnly]="false" [label]="'% Descuento'" formControlName="porcentaje_descuento"
          [disabled]="porcentajeDescuentoDisabled" type="number"></app-lfsa-input>
      </div>
      <hr>
      <div class="col-lg-3">
        <app-lfsa-input [control]="this.agregarForm.get('monto_inicial')" [id]="'monto_inicial'" [isReadOnly]="false"
          [label]="'Monto Inicial'" formControlName="monto_inicial" type="number"></app-lfsa-input>
      </div>
      <div class="col-lg-3">
        <app-lfsa-input [control]="this.agregarForm.get('monto_final')" [id]="'monto_final'" [isReadOnly]="false"
          [label]="'Monto Final'" formControlName="monto_final" type="number"></app-lfsa-input>
      </div>
      <div class="col-lg-3" *ngIf="!isCreate">
        <label for="cond_marca_submarca">Condición Marca/Submarca</label>
        <div class="input-group">
          <select class="form-control form-select" formControlName="cond_marca_submarca" id="cond_marca_submarca">
            <option value="">Seleccione una opción</option>
            <option *ngFor="let data of cmboInclusionExclusion" [value]="data.id">{{ data.descripcion }}</option>
          </select>
          <button
            class="btn btn-outline-success"
            [routerLink]="['submarca']"
            tooltip="Cond. submarca"
            [options]="{'placement': 'top', 'showDelay': 300}"
            *ngIf="condicionMarca">
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>
      <div class="col-lg-3">
        <app-lfsa-input [control]="this.agregarForm.get('numero_maximo_compras')" [id]="'numero_maximo_compras'"
          [isReadOnly]="false" [label]="'Número Máx. de Compras'" formControlName="numero_maximo_compras"
          [type]="'number'"></app-lfsa-input>
        <!-- <label for="numero_maximo_compras">Numero Máximo de Compras</label>
        <select class="form-control" formControlName="numero_maximo_compras" id="numero_maximo_compras">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let data of cmboInclusionExclusion" [innerHTML]="data.descripcion" [value]="data.id">
          </option>
        </select> -->
      </div>
      <div class="col-lg-3" *ngIf="!isCreate">
        <label for="cond_grupo_cliente">Condición Grupo Cliente</label>
        <div class="input-group">
          <select class="form-control form-select" formControlName="cond_grupo_cliente" id="cond_grupo_cliente">
            <option value="">Seleccione una opción</option>
            <option *ngFor="let data of cmboInclusionExclusion" [value]="data.id">{{ data.descripcion }}</option>
          </select>
          <button
            class="btn btn-outline-success"
            [routerLink]="['grupo-cliente']"
            [queryParams]="{
              desc: this.agregarForm.get('descripcion_corta').value
            }"
            tooltip="Cond. grupo cliente"
            [options]="{'placement': 'top', 'showDelay': 300}"
            *ngIf="condicionGrupo">
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>
      <div class="col-lg-3" *ngIf="!isCreate">
        <label for="cond_cliente">Condición Cliente</label>
        <div class="input-group">
          <select class="form-control form-select" formControlName="cond_cliente" id="cond_cliente">
            <option value="">Seleccione una opción</option>
            <option *ngFor="let data of cmboInclusionExclusion" [value]="data.id">{{ data.descripcion }}</option>
          </select>
          <button
            class="btn btn-outline-success"
            [routerLink]="['cliente']"
            [queryParams]="{
              tipo_promo: this.agregarForm.get('tipo_promo').value,
              desc: this.agregarForm.get('descripcion_corta').value
            }"
            tooltip="Cond. cliente"
            [options]="{'placement': 'top', 'showDelay': 300}"
            *ngIf="condicionCliente">
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>
      <div class="col-lg-3" *ngIf="!isCreate">
        <label for="cond_oficina_venta">Condición Oficina de Venta</label>
        <div class="input-group">
          <select class="form-control form-select" formControlName="cond_oficina_venta" id="cond_oficina_venta">
            <option value="">Seleccione una opción</option>
            <option *ngFor="let data of cmboInclusionExclusion" [value]="data.id">{{ data.descripcion }}</option>
          </select>
          <button
            class="btn btn-outline-success"
            [routerLink]="['oficina-venta']"
            tooltip="Cond. oficina venta"
            [options]="{'placement': 'top', 'showDelay': 300}"
            *ngIf="condicionOficina">
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>
      <div class="col-lg-3" *ngIf="!isCreate">
        <label for="cond_vendedor">Condición por Vendedor</label>
        <div class="input-group">
          <select class="form-control form-select" formControlName="cond_vendedor" id="cond_vendedor">
            <option value="">Seleccione una opción</option>
            <option *ngFor="let data of cmboInclusionExclusion" [value]="data.id">{{ data.descripcion }}</option>
          </select>
          <button
            class="btn btn-outline-success"
            [routerLink]="['vendedor']"
            tooltip="Cond. vendedor"
            [options]="{'placement': 'top', 'showDelay': 300}"
            *ngIf="condicionVendedor">
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>

      <div class="w-100" style="height: 10px;"></div>
      <!--<div class="form-row"> -->
        <div class="col-lg-3">
          <label for="negociacion_puntal">Negociación Puntual</label>
          <select class="form-control form-select" formControlName="negociacion_puntal" id="negociacion_puntal">
            <option value="">Seleccione una opción</option>
            <option *ngFor="let data of cmbSiNo" [value]="data.id">{{ data.descripcion }}</option>
          </select>
        </div>
        <!-- CONDICIONES POR TIER -->
        <div class="col-lg-3" *ngIf="!isCreate">
          <label for="cond_tiers">Tier</label>
          <div class="input-group">
          <select class="form-control form-select" formControlName="cond_tiers" id="cond_tiers">
            <option value="">Seleccione una opción</option>
            <option *ngFor="let data of cmboInclusionExclusion" [value]="data.id">{{ data.descripcion }}</option>
          </select>
            <button class="btn btn-outline-success" tooltip="Condición por Tier" 
                    [options]="{'placement': 'top', 'showDelay': 300}"
                    [routerLink]="['tiers']" 
                    *ngIf="condicionPorTier">
                    <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>

        <!--  T.20331 Essential: nuevas cond. para promos -->
        <!-- CONDICIONES POR CANAL VENDEDOR -->
        <div class="col-lg-3" *ngIf="!isCreate">
          <label for="cond_sub_canal">Agrupación Tarifa-SubCanal</label>
          <div class="input-group">
          <select class="form-control form-select" formControlName="cond_sub_canal" id="cond_sub_canal">
            <option value="">Seleccione una opción</option>
            <option *ngFor="let data of cmboInclusionExclusion" [value]="data.id">{{ data.descripcion }}</option>
          </select>
            <button class="btn btn-outline-success" tooltip="Condición por Agrupación Tarifa" 
                    [options]="{'placement': 'top', 'showDelay': 300}"
                    [routerLink]="['agrupacionTarifa']"  *ngIf="condicionAgrupaTarifa">
                    <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>

        <!-- CONDICIONES POR CANAL VENDEDOR -->
        <div class="col-lg-3" *ngIf="!isCreate">
          <label for="cond_canal_cliente">Canal Vendedor-Cliente</label>
          <div class="input-group">
          <select class="form-control form-select" formControlName="cond_canal_cliente" id="cond_canal_cliente">
            <option value="">Seleccione una opción</option>
            <option *ngFor="let data of cmboInclusionExclusion" [value]="data.id">{{ data.descripcion }}</option>
          </select>
            <button class="btn btn-outline-success" tooltip="Condición por Canal Vendedor" 
                    [options]="{'placement': 'top', 'showDelay': 300}"
                    [routerLink]="['canalVendedor']"  *ngIf="condicionCanalVendedor">
                    <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
        
      <!--</div> -->
    </div>

    <app-lfsa-botones-formulario (devolverAccion)="acciones($event)"
      [formularioValido]="agregarForm.valid && !fechaFinalMenorQueFechaInicial ? false : true"
      [loading]="loading" [textBoton]="'Guardar'" class="row mt-4">
    </app-lfsa-botones-formulario>
  </form>
</div>
